import { customElement, containerless } from "aurelia-framework";
import { bindable } from "aurelia-typed-observable-plugin";
import { SynchronizationPropertiesTable } from "./synchronization-properties-table";

@containerless
@customElement("synchronization-to-procore-properties-table")
export class SynchronizationToProcorePropertiesTable extends SynchronizationPropertiesTable {

}
